if (typeof exports !== "undefined") Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Size", {
  value: {
    height: require("prop-types").number.isRequired,
    width: require("prop-types").number.isRequired
  },
  configurable: true
});


//////////////////
// WEBPACK FOOTER
// /Users/remi/Documents/metabase/metabase-0.28.1/node_modules/react-virtualized/dist/es/AutoSizer/types.js
// module id = 1728
// module chunks = 7